export interface financeState {
    finance: any
  }

export const initialFinanceState: financeState = {
    finance: null
};